import React from "react";
import { ArrowRight, Play, Sparkles } from "lucide-react";
import { heroImage, SHOP_URL } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image + overlays */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Adventure vehicle on a rugged mountain trail"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0e0e10] via-[#0e0e10]/80 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0e0e10] via-transparent to-[#0e0e10]/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 pb-16">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          {/* Copy */}
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-[#f15a24] bg-[#f15a24]/10 border border-[#f15a24]/30 px-4 py-1.5 rounded-full">
              <Sparkles size={14} /> Welcome to Posi-Products
            </span>

            <h1 className="font-display font-medium text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mt-6">
              The best
              <br />
              <span className="text-[#f15a24]">connectors</span> you'll ever use
            </h1>

            <p className="text-neutral-300 text-lg mt-6 max-w-xl leading-relaxed">
              Reusable electrical connectors that simply hand tighten — no
              crimping, no slicing, no tools. Truly a connector built for the
              21st century.
            </p>

            <div className="flex flex-wrap items-center gap-4 mt-9">
              <a
                href="#connectors"
                className="group inline-flex items-center gap-2 bg-[#f15a24] hover:bg-[#ff6a34] text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-300 shadow-lg shadow-[#f15a24]/30 hover:shadow-[#f15a24]/50 hover:-translate-y-0.5"
              >
                See our connectors
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={SHOP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white font-semibold px-7 py-3.5 rounded-full border border-white/20 hover:border-white/50 hover:bg-white/5 transition-all duration-300"
              >
                Visit the shop
              </a>
            </div>

            {/* Stats */}
            <div className="flex gap-8 mt-12">
              {[
                { k: "300+", v: "Retailers" },
                { k: "2K+", v: "Riders" },
                { k: "0", v: "Tools needed" },
              ].map((s) => (
                <div key={s.v}>
                  <div className="font-display font-bold text-white text-3xl">{s.k}</div>
                  <div className="text-neutral-400 text-sm mt-1">{s.v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Product video card */}
          <div className="lg:col-span-5 animate-fade-up" style={{ animationDelay: "0.15s" }}>
            <div className="relative bg-[#161618] border border-white/10 rounded-3xl p-5 shadow-2xl">
              <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-[#1e1e22] to-[#101012] aspect-[4/3] flex items-center justify-center">
                <img
                  src="https://www.motousher.com/cdn/shop/products/Posi-TWIST_7434505a-4f82-4831-a0fe-e94d8e609ccb.jpg?v=1664731092&width=440"
                  alt="Posi connector"
                  className="w-2/3 h-2/3 object-contain animate-float"
                />
                <button className="absolute inset-0 flex items-center justify-center group">
                  <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#f15a24] shadow-xl shadow-[#f15a24]/40 group-hover:scale-110 transition-transform">
                    <Play size={26} className="text-white ml-1" fill="white" />
                  </span>
                </button>
              </div>
              <div className="mt-4 flex items-center justify-between px-1">
                <span className="text-[#f15a24] font-semibold text-sm tracking-wide">
                  Revolutionizing connector technology
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
